// Цена единицы товара с учётом priceConditions (тиры по количеству).
// priceConditions приходят отсортированными по убыванию quantity — берём первый
// тир, чей порог ≤ текущего количества (как unitPriceForQuantity в мобилке).
export function unitPriceForQuantity(params, quantity) {
  let price = (params && params.price) || 0;
  const pcs = (params && params.priceConditions) || [];
  for (let i = 0; i < pcs.length; i += 1) {
    if (pcs[i].quantity <= quantity) { price = pcs[i].price; break; }
  }
  return price;
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/price.js